export default "__VITE_ASSET__c4691fac__"